// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../htsFonts/FSSinclair-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 fill=%27black%27%3E%3Crect width=%2716%27 height=%2716%27 rx=%272%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "FS Sinclair Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype");
}

.drawer {
  position: fixed;
  top: 100px;
  right: -570px;
  height: 100vh;
  width: 470px;
  background-color: #a6dfd8;
  transition: right 0.3s ease-in-out;
  z-index: 10;
  opacity: 0.9;
}


.drawer.open {
  right: 0;
}

.drawer-content {
  padding: 20px;
}

.drawer-content li {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: 0px center;
  background-size: 8px 8px;
  text-align: left;
  margin-top: 15px;
}
.link {
  color: #000000;
  text-decoration: none;
  font-family: "FS Sinclair Bold";
  font-size: 26px;
  margin-left: 20px;
}

.submenu{
  font-size: 22px;
  padding: 0;
  
}

.link:hover {
  color: #ac263b;
}

.nested-links {
  margin-top: 20px;
}

.nested-links h4 {
  margin-bottom: 10px;
}

.nested-list {
  list-style-type: none;
  padding-left: 20px;
}

.rightSection{
  display: flex;
  justify-content: right;
  align-items: center;
  padding-right: 20px;
}
.navBar1{
  padding-bottom: 17px;
}
@media (max-width: 768px) {
  .drawer {
    width: 100%;
    top: 75px;
    z-index: 100;
  }

  .navBar1{
    padding-bottom:38px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/navigation.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,+DAA8D;AAChE;;AAEA;EACE,eAAe;EACf,UAAU;EACV,aAAa;EACb,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,kCAAkC;EAClC,WAAW;EACX,YAAY;AACd;;;AAGA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yDAA+K;EAC/K,4BAA4B;EAC5B,+BAA+B;EAC/B,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,UAAU;;AAEZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE;IACE,WAAW;IACX,SAAS;IACT,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["@font-face {\r\n  font-family: \"FS Sinclair Bold\";\r\n  src: url(\"../htsFonts/FSSinclair-Bold.otf\") format(\"opentype\");\r\n}\r\n\r\n.drawer {\r\n  position: fixed;\r\n  top: 100px;\r\n  right: -570px;\r\n  height: 100vh;\r\n  width: 470px;\r\n  background-color: #a6dfd8;\r\n  transition: right 0.3s ease-in-out;\r\n  z-index: 10;\r\n  opacity: 0.9;\r\n}\r\n\r\n\r\n.drawer.open {\r\n  right: 0;\r\n}\r\n\r\n.drawer-content {\r\n  padding: 20px;\r\n}\r\n\r\n.drawer-content li {\r\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='black'%3E%3Crect width='16' height='16' rx='2'/%3E%3C/svg%3E\");\r\n  background-repeat: no-repeat;\r\n  background-position: 0px center;\r\n  background-size: 8px 8px;\r\n  text-align: left;\r\n  margin-top: 15px;\r\n}\r\n.link {\r\n  color: #000000;\r\n  text-decoration: none;\r\n  font-family: \"FS Sinclair Bold\";\r\n  font-size: 26px;\r\n  margin-left: 20px;\r\n}\r\n\r\n.submenu{\r\n  font-size: 22px;\r\n  padding: 0;\r\n  \r\n}\r\n\r\n.link:hover {\r\n  color: #ac263b;\r\n}\r\n\r\n.nested-links {\r\n  margin-top: 20px;\r\n}\r\n\r\n.nested-links h4 {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.nested-list {\r\n  list-style-type: none;\r\n  padding-left: 20px;\r\n}\r\n\r\n.rightSection{\r\n  display: flex;\r\n  justify-content: right;\r\n  align-items: center;\r\n  padding-right: 20px;\r\n}\r\n.navBar1{\r\n  padding-bottom: 17px;\r\n}\r\n@media (max-width: 768px) {\r\n  .drawer {\r\n    width: 100%;\r\n    top: 75px;\r\n    z-index: 100;\r\n  }\r\n\r\n  .navBar1{\r\n    padding-bottom:38px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
